import axios from "axios";

export const CHANGE = "mainbase/CHANGE";

const initialState = {
	contract: "",
	plant: "",
	mid: "",
	state: "off", //off, saving, error, on
	loader: "waiting", //hidden, loading, waiting
	midstatus: "missing", //missing, ok, error, loading
	token: axios.CancelToken.source()
};

function mainbase(state = initialState, action) {
	switch (action.type) {
		case CHANGE:
			var newstate = { ...state };
			newstate[action.id] = action.val;
			return newstate;
		default:
			return state;
	}
}

export default mainbase;

export const save = () => {
	return (dispatch, getState) => {
		const state = getState();
		const contract = state.mainbase.contract;
		const plant = state.mainbase.plant;
		const mid = state.mainbase.mid;
		dispatch({
			type: CHANGE,
			id: "state",
			val: "saving"
		});
		//get mid from ajax
		state.mainbase.token.cancel(
			"Operation cancelled by following request."
		);
		var newToken = axios.CancelToken.source();
		dispatch({
			type: CHANGE,
			id: "token",
			val: newToken
		});
		axios
			.post(
				"bag.php",
				{
					action: "save",
					contract: contract,
					plant: plant,
					mid: mid
				},
				{ cancelToken: newToken.token }
			)
			.catch(function(e) {
				if (axios.isCancel(e)) {
					console.log("Request canceled", e.message);
				} else {
					dispatch({
						type: CHANGE,
						id: "state",
						val: "error"
					});
				}
			})
			.then(function(body) {
				if (typeof body === "undefined") return false;
				dispatch({
					type: CHANGE,
					id: "state",
					val: "on"
				});
			});
	};
};

export const checkMid = () => {
	return (dispatch, getState) => {
		const state = getState();
		const mid = state.mainbase.mid;
		if (mid === "") {
			dispatch({
				type: CHANGE,
				id: "midstatus",
				val: "empty"
			});
		} else {
			dispatch({
				type: CHANGE,
				id: "midstatus",
				val: "loading"
			});
			//check mid over ajax
			state.mainbase.token.cancel(
				"Operation cancelled by following request."
			);
			var newToken = axios.CancelToken.source()
			dispatch({
				type: CHANGE,
				id: "token",
				val: newToken
			});
			axios
				.post(
					"bag.php",
					{ action: "checkMid", mid: mid },
					{ cancelToken: newToken.token }
				)
				.catch(function(e) {
					if (axios.isCancel(e)) {
						console.log("Request canceled", e.message);
					} else {
						dispatch({
							type: CHANGE,
							id: "midstatus",
							val: "missing"
						});
					}
				})
				.then(function(body) {
					if (typeof body === "undefined") return false;

					dispatch({
						type: CHANGE,
						id: "midstatus",
						val: body.data
					});
				});
		}
	};
};

export const change = (name, value) => {
	return (dispatch, getState) => {
		dispatch({
			type: CHANGE,
			id: name,
			val: value
		});
		const state = getState();
		const contract = state.mainbase.contract;
		const plant = state.mainbase.plant;
		if (contract === "" || plant === "") {
			dispatch({
				type: CHANGE,
				id: "loader",
				val: "waiting"
			});
		} else {
			if (name !== "mid") {
				dispatch({
					type: CHANGE,
					id: "loader",
					val: "loading"
				});
				//get mid from ajax

				state.mainbase.token.cancel(
					"Operation cancelled by following request."
				);
				var newToken = axios.CancelToken.source()
				dispatch({
					type: CHANGE,
					id: "token",
					val: newToken
				});
				axios
					.post(
						"bag.php",
						{
							action: "getMid",
							contract: contract,
							plant: plant
						},
						{ cancelToken: newToken.token, transformResponse: undefined }
					)
					.catch(function(e) {
						if (axios.isCancel(e)) {
							console.log("Request canceled", e.message);
						} else {
							dispatch({
								type: CHANGE,
								id: "loader",
								val: "hidden"
							});
							dispatch({
								type: CHANGE,
								id: "mid",
								val: ""
							});
							dispatch({
								type: CHANGE,
								id: "midstatus",
								val: "empty"
							});
						}
					})
					.then(function(body) {
						if (typeof body === "undefined") return false;
						console.log(body);
						dispatch({
							type: CHANGE,
							id: "loader",
							val: "hidden"
						});
						dispatch({
							type: CHANGE,
							id: "midstatus",
							val: body.data !== "" ? "ok" : "empty"
						});
						dispatch({
							type: CHANGE,
							id: "mid",
							val: body.data
						});
					});
			} else {
				dispatch(checkMid());
			}
		}
	};
};



// WEBPACK FOOTER //
// ./src/modules/mainbase.js